export const APP_ROUTES = {
  GET_DATA_FOR_URI: "api/admin/loginCarousel",
  DEFAULT_LOGIN: "api/auth/signin",
  FORGOT_PASSWORD: "api/auth/resetpassword",
  GET_SSO_DETAILS: "api/admin/ssoProviders",
  GET_LOGO: "api/admin/logo",
  GET_TAGS: "api/language/tags",
};
